import React, { useState, useEffect } from "react";
import BotaoOuvir from "../components/BotaoOuvir";

const BASE_URL = "/api";
const PACOTE = { preco: 89.9, de: 249.9 };
const PAGOS = [
  { numero: 2, titulo: "Segurança na Prática", preco: 29.9, de: 69.9 },
  { numero: 3, titulo: "Pilotagem no Trânsito Urbano", preco: 29.9, de: 69.9 },
  { numero: 4, titulo: "Manutenção Básica", preco: 29.9, de: 69.9 },
  { numero: 5, titulo: "Aula Prática + Certificação (presencial em Sorriso-MT)", preco: 49.9, de: 99.9 },
];
const OURO = { fontFamily: "Outfit, sans-serif" };

function formatarPreco(v) { return v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }); }
function formatarData(iso) { try { return new Date(iso).toLocaleDateString("pt-BR"); } catch (e) { return ""; } }
function lerLocal(chave) { try { return window.localStorage.getItem(chave) || ""; } catch (e) { return ""; } }
function gravarLocal(chave, valor) { try { window.localStorage.setItem(chave, valor); } catch (e) {} }

function Texto({ conteudo }) {
  const linhas = (conteudo || "").split("\n");
  return (
    <div className="space-y-3 text-lg leading-relaxed">
      {linhas.map(function (l, i) {
        const t = l.trim();
        if (!t) return null;
        if (t.indexOf("## ") === 0) return <h2 key={i} className="text-2xl font-bold text-[#E2B84A] pt-4" style={OURO}>{t.slice(3)}</h2>;
        if (t.indexOf("- ") === 0) return <p key={i} className="flex gap-3 pl-2"><span className="text-[#E2B84A]">•</span><span>{t.slice(2)}</span></p>;
        return <p key={i}>{t}</p>;
      })}
    </div>
  );
}

export default function CursoGratisPage() {
  const [etapa, setEtapa] = useState("form");
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [aceite, setAceite] = useState(false);
  const [copiado, setCopiado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState("");
  const [aula, setAula] = useState(null);
  const [respostas, setRespostas] = useState({});
  const [resultado, setResultado] = useState(null);

  useEffect(function () {
    fetch(BASE_URL + "/curso/gratis/conteudo")
      .then(function (r) { return r.json(); })
      .then(setAula)
      .catch(function () { setErro("Não foi possível carregar a aula. Atualize a página."); });
    const salvo = lerLocal("giraia_gratis_email");
    try { const ind = new URLSearchParams(window.location.search).get("ind"); if (ind) gravarLocal("giraia_ind", ind); } catch (e) {}
    if (salvo) {
      setEmail(salvo);
      let d = null;
      try { d = JSON.parse(lerLocal("giraia_gratis_dados") || "null"); } catch (e) {}
      if (d && d.email === salvo) {
        setNome(d.nome); setWhatsapp(d.whatsapp);
        fetch(BASE_URL + "/curso/lead", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ nome: d.nome, email: d.email, whatsapp: d.whatsapp }) })
          .then(function (r) { return r.json(); })
          .then(function (x) { if (x && x.certificado) { setResultado(Object.assign({ aprovado: true }, x.certificado)); setEtapa("certificado"); } else { setEtapa("aula"); } })
          .catch(function () { setEtapa("aula"); });
      } else { setEtapa("aula"); }
    }
  }, []);

  function irPara(nova) { setEtapa(nova); window.scrollTo(0, 0); }

  async function enviarCadastro(ev) {
    ev.preventDefault();
    setErro(""); setEnviando(true);
    try {
      const resp = await fetch(BASE_URL + "/curso/lead", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ nome: nome, email: email, whatsapp: whatsapp, indicado_por: lerLocal("giraia_ind") }) });
      const dados = await resp.json().catch(function () { return {}; });
      if (!resp.ok) { setErro(typeof dados.detail === "string" ? dados.detail : "Não foi possível enviar. Tente de novo."); }
      else { gravarLocal("giraia_gratis_email", email.trim().toLowerCase()); gravarLocal("giraia_gratis_dados", JSON.stringify({ nome: nome, email: email.trim().toLowerCase(), whatsapp: whatsapp })); if (dados.certificado) { setResultado(Object.assign({ aprovado: true }, dados.certificado)); irPara("certificado"); } else { irPara("aula"); } }
    } catch (e) { setErro("Sem conexão. Tente de novo."); }
    setEnviando(false);
  }

  async function corrigir() {
    setErro(""); setEnviando(true);
    const lista = aula.quiz.map(function (q, i) { return respostas[i] === undefined ? -1 : respostas[i]; });
    try {
      const resp = await fetch(BASE_URL + "/curso/gratis/quiz", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email: email, respostas: lista }) });
      const dados = await resp.json().catch(function () { return {}; });
      if (!resp.ok) {
        setErro(typeof dados.detail === "string" ? dados.detail : "Não foi possível corrigir. Tente de novo.");
        if (resp.status === 404) { gravarLocal("giraia_gratis_email", ""); irPara("form"); }
      } else { setResultado(dados); irPara(dados.aprovado ? "certificado" : "resultado"); }
    } catch (e) { setErro("Sem conexão. Tente de novo."); }
    setEnviando(false);
  }

  const campo = "w-full rounded-xl bg-[#141118] border border-[#3A3442] px-4 py-4 text-lg text-[#F2F0EA] placeholder-[#9A948A] focus:outline-none focus:border-gold-500";
  const total = aula ? aula.quiz.length : 0;
  const respondidas = Object.keys(respostas).length;

  return (
    <div className="min-h-screen bg-[#141118] text-[#F2F0EA] flex flex-col items-center px-4 py-10 print:bg-white print:p-0 print:min-h-0" style={{ fontFamily: "Manrope, sans-serif" }}>
      <div className="w-full max-w-2xl print:max-w-none">
        <div className="text-center mb-8 print:hidden">
          <img src="/logo-giraia.jpg" alt="Giraia Bike Shop Logo" className="w-44 h-44 sm:w-56 sm:h-56 mx-auto mb-4 object-contain" />
          <h1 className="text-3xl sm:text-4xl font-black text-[#E2B84A] mb-2 tracking-tight" style={OURO}>Aula Grátis</h1>
          <p className="text-lg text-[#B8B3A8]">Seu filho pode andar de patinete, bike elétrica ou scooter? Aprenda as leis e as regras e ganhe um certificado.</p>
        </div>
        {erro && etapa !== "form" && <p className="text-red-400 text-lg mb-4 print:hidden">{erro}</p>}

        {etapa === "form" && (
          <form onSubmit={enviarCadastro} className="bg-[#1E1A24] rounded-2xl p-6 sm:p-8 space-y-4">
            <p className="text-lg">Preencha seus dados para assistir à aula gratuita:</p>
            <p className="text-[#B8B3A8]">{"J\u00e1 fez a aula? Use o mesmo e-mail para ver seu certificado de novo."}</p>
            <input className={campo} placeholder="Seu nome completo (vai no certificado)" value={nome} onChange={function (e) { setNome(e.target.value); }} required />
            <input className={campo} type="email" placeholder="Seu e-mail" value={email} onChange={function (e) { setEmail(e.target.value); }} required />
            <input className={campo} type="tel" placeholder="Seu WhatsApp com DDD" value={whatsapp} onChange={function (e) { setWhatsapp(e.target.value); }} required />
            <label className="flex items-start gap-3 text-base bg-[#141118] rounded-xl p-4 border border-[#3A3442]"><input type="checkbox" required checked={aceite} onChange={function (e) { setAceite(e.target.checked); }} className="mt-1 w-6 h-6 shrink-0" /><span>{"Sou maior de 18 anos, ou sou o pai, a m\u00e3e ou o respons\u00e1vel legal e autorizo este cadastro. Li e concordo com a "}<a href="/privacidade.html" target="_blank" rel="noopener noreferrer" className="text-[#E2B84A] underline">{"Pol\u00edtica de Privacidade"}</a>.</span></label>
            {erro && <p className="text-red-400 text-lg">{erro}</p>}
            <button type="submit" disabled={enviando} className="w-full rounded-xl bg-gold-500 text-[#141118] font-bold text-xl py-4 disabled:opacity-60">
              {enviando ? "Enviando..." : "Quero a aula grátis"}
            </button>
            <p className="text-sm text-[#9A948A]">Ao enviar, você aceita receber contato da Giraia Bike Shop por WhatsApp e e-mail.</p>
          </form>
        )}

        {etapa === "aula" && (
          <div className="bg-[#1E1A24] rounded-2xl p-6 sm:p-8">
            {!aula ? <p className="text-lg">Carregando a aula...</p> : (
              <div>
                <h2 className="text-3xl font-black text-[#E2B84A] mb-4" style={OURO}>Módulo 1 - {aula.titulo}</h2>
                <p className="text-sm text-[#b9b4aa] mb-3">Conteúdo atualizado em outubro/2026</p>
                <BotaoOuvir texto={aula.conteudo_texto} />
                <Texto conteudo={aula.conteudo_texto} />
                <button onClick={function () { irPara("quiz"); }} className="mt-8 w-full rounded-xl bg-gold-500 text-[#141118] font-bold text-xl py-4">Fazer o quiz e ganhar o certificado</button>
              </div>
            )}
          </div>
        )}

        {etapa === "quiz" && aula && (
          <div className="space-y-5">
            <p className="text-lg text-[#B8B3A8]">Responda as {total} perguntas. Para ganhar o certificado, acerte pelo menos 70%.</p>
            {aula.quiz.map(function (q, i) {
              return (
                <div key={i} className="bg-[#1E1A24] rounded-2xl p-5 sm:p-6">
                  <p className="text-lg font-bold mb-4">{(i + 1) + ". " + q.pergunta}</p>
                  <div className="space-y-3">
                    {q.opcoes.map(function (op, j) {
                      const marcada = respostas[i] === j;
                      return (
                        <button key={j} type="button" onClick={function () { const nova = Object.assign({}, respostas); nova[i] = j; setRespostas(nova); }}
                          className={"w-full text-left rounded-xl border px-4 py-4 text-lg " + (marcada ? "border-gold-500 bg-gold-500 text-[#141118] font-bold" : "border-[#3A3442] bg-[#141118] text-[#F2F0EA]")}>
                          {op}
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
            {erro && <p className="text-red-400 text-lg text-center">{erro}</p>}
            <button onClick={corrigir} disabled={enviando || respondidas < total} className="w-full rounded-xl bg-gold-500 text-[#141118] font-bold text-xl py-4 disabled:opacity-50">
              {respondidas < total ? "Responda todas (" + respondidas + " de " + total + ")" : (enviando ? "Corrigindo..." : "Ver meu resultado")}
            </button>
            <button onClick={function () { irPara("aula"); }} className="w-full text-[#B8B3A8] underline text-lg">Voltar para a aula</button>
          </div>
        )}

        {etapa === "resultado" && resultado && (
          <div className="bg-[#1E1A24] rounded-2xl p-6 sm:p-8 text-center space-y-4">
            <h2 className="text-3xl font-black text-[#E2B84A]" style={OURO}>Quase lá!</h2>
            <p className="text-xl">Você acertou {resultado.acertos} de {resultado.total} ({resultado.nota}%).</p>
            <p className="text-lg text-[#B8B3A8]">Para o certificado, é preciso acertar 70%. Reveja as perguntas {resultado.erradas.map(function (n) { return n + 1; }).join(", ")} e tente de novo.</p>
            <button onClick={function () { setRespostas({}); irPara("aula"); }} className="w-full rounded-xl bg-gold-500 text-[#141118] font-bold text-xl py-4">Rever a aula</button>
            <button onClick={function () { setRespostas({}); irPara("quiz"); }} className="w-full rounded-xl border border-gold-500 text-gold-500 font-bold text-xl py-4">Tentar de novo</button>
          </div>
        )}

        {etapa === "certificado" && resultado && (
          <div className="space-y-6">
            <style>{"@media print { @page { size: A4 landscape; margin: 8mm; } html, body { height: auto !important; min-height: 0 !important; } }"}</style>
            <div className="rounded-2xl p-2 bg-[#E2B84A] print:rounded-none print:h-[180mm] print:break-inside-avoid" style={{ WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }}>
              <div className="rounded-xl bg-[#FFFDF7] text-[#141118] p-6 sm:p-10 text-center border-4 border-double border-[#B8902E] print:h-full print:flex print:flex-col print:justify-center print:px-20">
                <div className="w-32 h-32 mx-auto mb-4 rounded-full bg-[#141118] flex items-center justify-center ring-4 ring-[#E2B84A]"><img src="/logo-giraia.jpg" alt="Giraia Bike Shop" className="w-28 h-28 object-contain rounded-full" /></div>
                <p className="tracking-[0.3em] text-sm text-[#8A6A1E] font-bold">CERTIFICADO DE CONCLUSÃO</p>
                <h2 className="text-2xl sm:text-3xl font-black mt-2 mb-6" style={OURO}>Módulo 1: Leis e Regras 2026</h2>
                <p className="text-lg">Certificamos que</p>
                <p className="text-3xl sm:text-4xl font-black my-3 text-[#8A6A1E]" style={OURO}>{resultado.nome}</p>
                <p className="text-lg leading-relaxed">concluiu o Módulo 1 do Curso Livre de Segurança para Patinetes, Bikes Elétricas e Scooters da Giraia Bike Shop{resultado.nota ? ", com aproveitamento de " + resultado.nota + "%." : "."}</p>
                <div className="flex justify-between gap-4 mt-8 text-sm text-[#5A5248]">
                  <span>Data: {formatarData(resultado.data)}</span>
                  <span>Código: {resultado.codigo}</span>
                </div>
                <p className="text-xs text-[#5A5248] mt-6">Curso livre de segurança. Não é documento oficial de trânsito e não substitui a habilitação. Giraia Bike Shop - Sorriso, MT.</p>
              </div>
            </div>
            <button onClick={function () { window.print(); }} className="w-full rounded-xl bg-gold-500 text-[#141118] font-bold text-xl py-4 print:hidden">Baixar certificado em PDF</button>
            <p className="text-center text-[#9A948A] print:hidden">Na janela que abrir, escolha "Salvar como PDF".</p>

            {resultado.indicacao && (
              <div className="bg-[#1E1A24] rounded-2xl p-6 sm:p-8 border-2 border-[#E2B84A] print:hidden">
                <h2 className="text-3xl font-black text-[#E2B84A] mb-3" style={OURO}>Indique e ganhe</h2>
                <p className="text-lg mb-4">Cada amigo que fizer a aula grátis pelo seu link e tirar o certificado vale <b>1 ponto</b>:</p>
                <div className="space-y-2 mb-5 text-lg">
                  <p><b className="text-[#E2B84A]">1 amigo:</b> brinde surpresa da loja</p>
                  <p><b className="text-[#E2B84A]">2 amigos:</b> busca e entrega grátis em Sorriso em um serviço da oficina</p>
                  <p><b className="text-[#E2B84A]">4 amigos:</b> R$ 100 de desconto na mão de obra da revisão completa</p>
                </div>
                <div className="bg-[#141118] rounded-xl p-4 mb-5 text-center">
                  <p className="text-2xl font-black" style={OURO}>Você tem {resultado.indicacao.pontos} {resultado.indicacao.pontos === 1 ? "ponto" : "pontos"}</p>
                  <p className="text-lg text-[#B8B3A8]">{resultado.indicacao.proximo ? "Falta " + resultado.indicacao.proximo.faltam + (resultado.indicacao.proximo.faltam === 1 ? " amigo" : " amigos") + " para: " + resultado.indicacao.proximo.premio : "Você já ganhou todos os prêmios. Obrigada!"}</p>
                </div>
                <a href={"https://wa.me/?text=" + encodeURIComponent("Fiz a aula grátis de segurança para patinete, bike elétrica e scooter da Giraia Bike Shop e ganhei certificado! Faz também, é rapidinho: " + resultado.indicacao.link)} target="_blank" rel="noopener noreferrer" className="block w-full text-center rounded-xl bg-[#25D366] text-white font-bold text-xl py-4 mb-3">Indicar pelo WhatsApp</a>
                <button onClick={function () { try { navigator.clipboard.writeText(resultado.indicacao.link); setCopiado(true); } catch (e) {} }} className="w-full rounded-xl border border-gold-500 text-gold-500 font-bold text-lg py-3">{copiado ? "Link copiado!" : "Copiar meu link"}</button>
                <p className="text-sm text-[#9A948A] mt-4">Os pontos valem por 90 dias. Quando ganhar um prêmio, você recebe um e-mail para retirar na loja (Av. Ademar Raiter, 428, Sorriso-MT). Um prêmio de cada nível por pessoa. Peças cobradas à parte.</p>
              </div>
            )}

            <div className="bg-[#1E1A24] rounded-2xl p-6 sm:p-8 border border-gold-500 print:hidden">
              <h2 className="text-2xl font-bold text-[#E2B84A] mb-3" style={OURO}>Parabéns! Quer continuar?</h2>
              <p className="text-lg mb-6">Agora que você conhece as regras, aprenda na prática a se proteger: segurança no dia a dia, como andar no meio dos carros e como cuidar do seu veículo.</p>
              <a href="/curso/comprar/pacote" className="block bg-gold-500 text-[#141118] rounded-xl p-5 text-center mb-4">
                <span className="block font-black text-xl" style={OURO}>Pacote completo: Módulos 2 a 5</span>
                <span className="block text-lg"><s>{formatarPreco(PACOTE.de)}</s> por <b>{formatarPreco(PACOTE.preco)}</b></span>
              </a>
              <p className="text-[#B8B3A8] mb-3">Ou escolha um módulo:</p>
              <div className="space-y-3">
                {PAGOS.map(function (m) {
                  return (
                    <div key={m.numero} className="flex items-center justify-between gap-4 bg-[#141118] rounded-xl p-4">
                      <div>
                        <p className="font-bold text-lg">Módulo {m.numero} - {m.titulo}</p>
                        <p className="text-[#E2B84A] text-lg">{m.de && <s className="text-gray-400 text-sm mr-2">{formatarPreco(m.de)}</s>}{formatarPreco(m.preco)}</p>
                      </div>
                      <a href={"/curso/comprar/" + m.numero} className="shrink-0 rounded-xl border border-gold-500 text-gold-500 font-bold px-5 py-3">Comprar</a>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
